import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appPhoneFormat]',
    standalone: false
})
export class PhoneFormatDirective {
  constructor(private readonly el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, ''); // Remove all non-digit characters

    // Format the phone number as XXX-XXX-XXXX
    let formattedValue = '';
    if (value.length <= 3) {
      formattedValue = value;
    } else if (value.length <= 6) {
      formattedValue = `${value.slice(0, 3)}-${value.slice(3)}`;
    } else {
      formattedValue = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(
        6,
        10
      )}`;
    }

    // Set the formatted value
    input.value = formattedValue;
  }
}
